/**
 * Dedicated cart page — URL: /panier
 * Opens the existing CartSheet on mount. When user closes it, navigates home.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLang, useCart } from "../lib/providers";
import { goBack } from "../lib/navHelpers";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppFloater from "../components/WhatsAppFloater";
import CartSheet from "../components/CartSheet";

export default function CartPage() {
  const { lang } = useLang();
  const { setOpen, open } = useCart();
  const navigate = useNavigate();

  useEffect(() => { setOpen(true); }, [setOpen]);
  useEffect(() => { document.title = lang === "ar" ? "سلتي — DZ TENNIS SHOP" : "Mon panier — DZ TENNIS SHOP"; }, [lang]);

  // Quand le client ferme le panier : retour à la page précédente (accueil seulement s'il n'y en a pas)
  useEffect(() => {
    if (open === false) {
      const t = setTimeout(() => goBack(navigate), 250);
      return () => clearTimeout(t);
    }
  }, [open, navigate]);

  return (
    <div className="min-h-screen text-white overflow-x-hidden" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Header />
      <main className="pt-16 pb-32 px-4">
        <div className="max-w-5xl mx-auto text-center py-12">
          <h1 className="font-heading font-black uppercase tracking-tight text-4xl sm:text-5xl">
            {lang === "ar" ? "🛒 السلة" : "🛒 Mon panier"}
          </h1>
          <p className="text-white/50 mt-3 text-sm">
            {lang === "ar" ? "أكمل طلبك في النافذة الجانبية" : "Finalisez votre commande dans le panneau latéral"}
          </p>
        </div>
      </main>
      <Footer onAdminClick={() => {}} />
      <WhatsAppFloater />
      <CartSheet />
    </div>
  );
}
